/* Kkumi clean navbar — mega menu, mobile drawer, sticky behaviour, search.
   Extracted from sections/kkumi-navbar-clean.liquid. */
(function () {
  // Root carries its section id in the element id (kkncl-<section.id>).
  var root = document.querySelector('.kkncl[id^="kkncl-"]');
  if (!root) return;
  var SID = root.id.slice('kkncl-'.length);

  var scrim = document.getElementById('kkncl-scrim-' + SID);
  var closeTimer;

  /* ---------------- mega menu ---------------- */
  var megaItems = Array.prototype.slice.call(root.querySelectorAll('.kkncl__nav-item.has-megamenu'));

  function openMega(item) {
    clearTimeout(closeTimer);
    closeSearch();
    megaItems.forEach(function (other) {
      if (other !== item) setItemOpen(other, false);
    });
    setItemOpen(item, true);
    if (scrim) scrim.classList.add('is-on');
  }
  function closeMega() {
    megaItems.forEach(function (item) { setItemOpen(item, false); });
    if (!root.classList.contains('is-search') && scrim) scrim.classList.remove('is-on');
  }
  function setItemOpen(item, open) {
    item.classList.toggle('is-open', open);
    var link = item.querySelector('.kkncl__link');
    if (link) link.setAttribute('aria-expanded', String(open));
  }
  function scheduleClose() { closeTimer = setTimeout(closeMega, 140); }
  function cancelClose() { clearTimeout(closeTimer); }

  megaItems.forEach(function (item) {
    var link = item.querySelector('.kkncl__link');
    var mega = item.querySelector('.kkncl__mega');

    item.addEventListener('mouseenter', function () { openMega(item); });
    item.addEventListener('mouseleave', scheduleClose);
    if (mega) {
      mega.addEventListener('mouseenter', cancelClose);
      mega.addEventListener('mouseleave', scheduleClose);
    }
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) closeMega(); else openMega(item);
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('is-open')) closeMega(); else openMega(item);
        } else if (e.key === 'Escape') {
          closeMega();
        }
      });
    }
  });

  /* ---------------- search drawer ---------------- */
  var searchBtn = document.getElementById('kkncl-search-btn-' + SID);
  var searchInput = document.getElementById('kkncl-search-input-' + SID);

  function closeSearch() {
    root.classList.remove('is-search');
    if (searchBtn) searchBtn.classList.remove('is-active');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
  }
  if (searchBtn) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = root.classList.toggle('is-search');
      searchBtn.classList.toggle('is-active', open);
      searchBtn.setAttribute('aria-expanded', String(open));
      if (open) {
        closeMega();
        if (scrim) scrim.classList.add('is-on');
        setTimeout(function () { if (searchInput) searchInput.focus(); }, 80);
      } else if (scrim) {
        scrim.classList.remove('is-on');
      }
    });
  }

  /* ---------------- scrim + escape ---------------- */
  function closeAll() { closeMega(); closeSearch(); if (scrim) scrim.classList.remove('is-on'); }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target) && (scrim && !scrim.contains(e.target))) {
      megaItems.forEach(function (item) { setItemOpen(item, false); });
    }
  });

  /* ---------------- sticky (fixed + placeholder) + condense ---------------- */
  var placeholder = document.getElementById('kkncl-placeholder-' + SID);
  var stuck = false;
  var headerTop = 0;
  /* Publish the rendered header height as a global CSS var so sticky
     rails elsewhere (cart summary, collection filters, PDP buy box,
     policy TOCs…) can offset their `top` and not get cut off by the
     fixed navbar. Re-synced after the condense padding transition. */
  var varTimer = null;
  function syncHeightVar() {
    document.documentElement.style.setProperty('--header-height', root.offsetHeight + 'px');
  }
  function scheduleHeightVar() {
    clearTimeout(varTimer);
    varTimer = setTimeout(syncHeightVar, 260);
  }
  function measure() {
    // distance from top of document to the header's normal position
    var rect = (stuck ? placeholder : root).getBoundingClientRect();
    headerTop = rect.top + window.pageYOffset;
    if (placeholder) placeholder.style.height = root.offsetHeight + 'px';
    syncHeightVar();
  }
  function onScroll() {
    var y = window.pageYOffset;
    var shouldStick = y > headerTop;
    if (shouldStick !== stuck) {
      stuck = shouldStick;
      if (placeholder) placeholder.style.display = stuck ? 'block' : 'none';
      root.classList.toggle('kkncl-fixed', stuck);
    }
    var condensed = y > headerTop + 24;
    if (condensed !== root.classList.contains('is-scrolled')) {
      root.classList.toggle('is-scrolled', condensed);
      scheduleHeightVar();
    }
  }
  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { stuck = false; root.classList.remove('kkncl-fixed'); if (placeholder) placeholder.style.display = 'none'; measure(); onScroll(); });
  window.addEventListener('load', function () { measure(); onScroll(); });

  /* ---------------- mobile off-canvas panel ---------------- */
  /* Portal the panel to <body> so it escapes the section's stacking context
     (no z-index can lift it otherwise). Clean up any stale copy first so
     theme-editor re-renders don't pile up duplicates. */
  var portalSel = '[data-kkncl-portal="' + SID + '"]';
  Array.prototype.slice.call(document.querySelectorAll('body > ' + portalSel)).forEach(function (el) { el.parentNode.removeChild(el); });
  var mWrap = document.querySelector(portalSel);
  if (mWrap && mWrap.parentNode !== document.body) {
    document.body.appendChild(mWrap);
  }

  var burger = document.getElementById('kkncl-burger-' + SID);
  var mPanel = document.getElementById('kkncl-mobile-panel-' + SID);
  var mobileClose = document.getElementById('kkncl-mobile-close-' + SID);
  var mobileOverlay = document.getElementById('kkncl-mobile-overlay-' + SID);
  function toggleMobile(open) {
    document.body.classList.toggle('kkncl-mobile-open', open);
    if (burger) burger.setAttribute('aria-expanded', String(open));
  }
  if (burger) burger.addEventListener('click', function () { closeMega(); closeSearch(); toggleMobile(true); });
  if (mobileClose) mobileClose.addEventListener('click', function () { toggleMobile(false); });
  if (mobileOverlay) mobileOverlay.addEventListener('click', function () { toggleMobile(false); });
  // Swipe the panel back to the left to close it (shared gesture, assets/kkumi-swipe-dismiss.js).
  if (mPanel && window.KKSwipe) {
    window.KKSwipe.attach(mPanel, {
      edge: 'left',
      enabled: function () { return document.body.classList.contains('kkncl-mobile-open'); },
      onClose: function () { toggleMobile(false); }
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('kkncl-mobile-open')) toggleMobile(false);
  });
  window.addEventListener('resize', function () {
    // Lockstep with the mobile breakpoint in sections/kkumi-navbar-clean.liquid.
    if (window.innerWidth > 1060 && document.body.classList.contains('kkncl-mobile-open')) toggleMobile(false);
  });

  /* accordion inside the panel (Shop + any menu item with children) */
  if (mPanel) {
    mPanel.querySelectorAll('.kkncl-mlink[data-macc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.kkncl-mitem');
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', String(willOpen));
      });
    });
  }

  /* ---------------- cart bubble ---------------- */
  var cartIconBubble = document.getElementById('cart-icon-bubble');
  if (cartIconBubble) {
    var initialCartIcon = (cartIconBubble.querySelector('svg, img') || {}).outerHTML
      || '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

    function setCartCount(count) {
      count = count || 0;
      cartIconBubble.innerHTML = initialCartIcon
        + '<span class="kkncl-bubble-count" style="display: ' + (count > 0 ? 'flex' : 'none') + ' !important;">'
        + (count > 99 ? '99+' : count) + '</span>';
    }

    /* If a Dawn cart-drawer/notification is present, it re-renders
       #cart-icon-bubble — mirror that into our markup.
       Also handles the case where cart.js replaces the <a> tag's innerHTML
       with content from the cart-icon-bubble section (.kkumi-bubble-count). */
    var cartObserver = new MutationObserver(function () {
      if (cartIconBubble.querySelector('.svg-wrapper, .icon-cart-empty, .cart-count-bubble, .kkumi-bubble-count')) {
        var m = cartIconBubble.textContent.match(/\d+/);
        setCartCount(m ? parseInt(m[0], 10) : 0);
      }
    });
    cartObserver.observe(cartIconBubble, { childList: true });

    /* The theme's cart-toast intercepts /cart/add and fires cart:added but
       doesn't touch the icon, so refresh the count straight from the Cart
       API. Covers all add-to-cart paths without needing cart-notification. */
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // From Theme settings > Cart (data-signature-variant on the root); 0 = none set.
    var SIGNATURE_VARIANT_ID = Number(root.dataset.signatureVariant) || 0;
    function refreshCartCount() {
      fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = 0;
          if (cart.items) {
            cart.items.forEach(function (item) {
              if (item.variant_id !== SIGNATURE_VARIANT_ID) {
                count += item.quantity;
              }
            });
          }
          setCartCount(count);
        })
        .catch(function () {});
    }
    ['cart:added', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, refreshCartCount);
    });
  }

  /* ---------------- wishlist mirror (swish-wishlist-king → visible heart) ---------------- */
  /* Ported verbatim from navigation.liquid (Kkumi Header). */
  var appWrapper = root.querySelector('.kkncl-app-wrapper');
  var customBubble = document.getElementById('kkncl-wishlist-bubble-' + SID);
  var customLink = document.getElementById('kkncl-wishlist-link-' + SID);
  var mWishLink = document.getElementById('kkncl-mwishlist-link-' + SID);
  var mWishBubble = document.getElementById('kkncl-mwishlist-bubble-' + SID);

  function applyCountToLink(link, bubble, count) {
    if (!link || !bubble) return;
    bubble.textContent = count > 99 ? '99+' : count;
    bubble.style.setProperty('display', count > 0 ? 'flex' : 'none', 'important');
    link.setAttribute('data-wk-count', String(count));
  }
  function applyWishlistCount(count) {
    applyCountToLink(customLink, customBubble, count);
    applyCountToLink(mWishLink, mWishBubble, count);
  }

  // Two count sources can drive the bubble:
  //   1) wk:countUpdated from kkumi-wishlist-core.js (our worker; the truth);
  //   2) the legacy swish-wishlist-king @app block, mirrored from its hidden
  //      DOM via MutationObserver + 1.2s poll.
  // The app block keeps its own internal count and won't sync with our worker
  // (e.g. a deleted product we cleaned still shows there), so as soon as our
  // own event fires we lock the bubble to that source and stop the mirror.
  var workerOwns = false;
  var wishlistInterval = null;
  var wishlistObserver = null;

  function mirrorWishlist() {
    if (workerOwns) return;
    if (!appWrapper) return;
    var appBubble = appWrapper.querySelector('[class*="count"], [class*="bubble"], .wk-counter');
    if (!appBubble) return;
    var m = appBubble.textContent.match(/\d+/);
    var count = m ? parseInt(m[0], 10) : 0;
    applyWishlistCount(count);
  }

  if (appWrapper && (customBubble || mWishBubble)) {
    wishlistObserver = new MutationObserver(mirrorWishlist);
    wishlistObserver.observe(appWrapper, { childList: true, subtree: true, characterData: true });
    wishlistInterval = setInterval(mirrorWishlist, 1200);
    mirrorWishlist();
  }

  document.addEventListener('wk:countUpdated', function (e) {
    // Only trust events from our worker (kkumi-wishlist-core marks them
    // `source: 'kkwl'`). The embedded swish-wishlist-king @app block also
    // re-dispatches `wk:countUpdated` from its own stale internal state on
    // every heart click, which would flash the bubble (e.g. 0 → 1 → 0 when
    // removing the last item).
    if (!(e && e.detail && e.detail.source === 'kkwl')) return;
    workerOwns = true;
    if (wishlistInterval) { clearInterval(wishlistInterval); wishlistInterval = null; }
    if (wishlistObserver) { wishlistObserver.disconnect(); wishlistObserver = null; }
    var count = Number(e.detail.count) || 0;
    applyWishlistCount(count);
  });
})();
